import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-admin-profile',
    templateUrl: './admin-profile.component.html',
    styleUrls: ['./admin-profile.component.scss'],
    standalone: false
})
export class AdminProfileComponent {
  pageName=CheckPageAccess.DASHBOARDADMIN;
  constructor(private router:Router,private authservice:AuthService) { }
  navigate()
  {
    this.router.navigate(['/edit-admin-profile/'+this.authservice.getUserLoginData().userDbId]);
  }
}
